import { useEffect } from 'react'
import { connectRealtime, disconnectRealtime } from '../services/realtime'
import { useAuthStore } from '../store'

export default function useRealtimeConnection({ enabled = true } = {}) {
  const { token, tenant } = useAuthStore()

  useEffect(() => {
    if (!enabled) {
      disconnectRealtime()
      return
    }

    if (!token || !tenant?.id) {
      disconnectRealtime()
      return
    }

    connectRealtime({ token, tenantId: tenant.id })

    return () => {
      disconnectRealtime()
    }
  }, [enabled, token, tenant?.id])
}
